import React from "react";
import Hero from "./Hero";

export default function Layouts({children, pageTitle, breadcrumbs = []}) {
    return (
        <>
            <Hero pageTitle={pageTitle} breadcrumbs={breadcrumbs}/>
            {children && children}
        </>
    );
}
